import api from './index';
import { axios } from '@/utils/request';

export function getTeacherList(data) {
    return axios({
        url: api.TEACHER_LIST,
        method: 'GET'
    });
}